import { Icon } from './Icon';

interface EyeToggleProps {
  /** DOM id. Toggles repeat (one per password field / table row), so callers
   *  derive this from their field or row rather than hardcoding. */
  id?: string;
  revealed: boolean;
  onChange: (revealed: boolean) => void;
  /** Optional context appended to the accessible label so repeated toggles
   *  (e.g. one per row in a table) are distinguishable to screen readers,
   *  yielding "Reveal password for row 1". Omit for single-field forms. */
  label?: string;
}

export function EyeToggle({ id, revealed, onChange, label }: EyeToggleProps): JSX.Element {
  const action = revealed ? 'Hide password' : 'Reveal password';
  return (
    <button
      id={id}
      type="button"
      aria-label={label ? `${action} for ${label}` : action}
      onClick={() => onChange(!revealed)}
      className="p-1 rounded-hbs-sm text-hbs-text-mute hover:text-hbs-text hover:bg-hbs-surface-alt"
    >
      <Icon name={revealed ? 'eyeOff' : 'eye'} size={16} />
    </button>
  );
}
